import { AbstractControl, ValidatorFn } from '@angular/forms';
import moment from 'moment';
import { constants } from '../constants/constants';

export function dobLessThan6Months(departureDate: moment.Moment): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const date = moment(control.value, constants.DATE_FORMAT.DATEPICKER, true);
		if (date && departureDate) {
			if (!date.isValid()) {
				return null;
			}
			const difference = departureDate.diff(date, 'months', true);
			if (difference >= 0 && difference < 6) {
				return { dobLessThan6Months: true };
			} else if (difference < 0) {
				return { dobAfterSailing: true };
			} else {
				return null;
			}
		}
		return null;
	};
}

export function dateValidator(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const date = moment(control.value, constants.DATE_FORMAT.DATEPICKER, true);
		const dateObj = getDateAsObj(control.value, constants.DATE_FORMAT.DATEPICKER);
		const enteredYear = dateObj.year ? parseInt(dateObj.year, 10) : 0;
		const isYearAfterDefault = constants.DEFAULT_YEAR - enteredYear <= 0;

		if (!date.isValid() || !isYearAfterDefault) {
			if (!dateObj.month || !dateObj.day || !dateObj.year) {
				return { required: { month: !dateObj.month, day: !dateObj.day, year: !dateObj.year } };
			}
			return { invalidDate: { value: control.value } };
		}

		return null;
	};
}

export function dobAfterToday(): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const dobDate = moment(control.value, constants.DATE_FORMAT.DATEPICKER, true);
		const today = moment();

		if (today.diff(dobDate, 'days') <= 0) {
			return { dobAfterToday: { value: control.value } };
		}

		return null;
	};
}

export function getDateAsObj(date: string, format: string) {
	const result = date ? date.split('-') : [];
  if (result.length && format === constants.DATE_FORMAT.DATEPICKER) {
    return { month: result[0], day: retrieveValueByLength(result, 1), year: retrieveValueByLength(result, 2) };
  }

  if (result.length && format !== constants.DATE_FORMAT.DATEPICKER) {
    return { year: result[0], month: retrieveValueByLength(result, 1), day: retrieveValueByLength(result, 2) };
  }
	return { month: '', day: '', year: '' };
}

export function retrieveValueByLength(result: string[], length: number): string {
  return result.length > length ? result[length] : '';
}
